//@ts-nocheck
import React from "react";
import styles from "./ContinuationDataForm.module.scss";
import useCustomForm from "hooks/useCustomForm";
import EditContinuationActions from "./EditContinuationActions/EditContinuationActions";
import { TextFieldWrapper } from "@factorearth/component-library";

function ContinuationDataForm(props) {
	const { continuationData, handleSubmitCb, color, fieldTemplate } = props;

	const { values, errors, changed, handleChange, handleUpdate, handleSubmit } = useCustomForm(continuationData, handleSubmitCallback);

	function handleSubmitNewContinuationActions(data) {
		const event = {
			target: {
				name: "continuationActions",
				value: data,
			},
		};

		handleChange(event);
	}

	function handleSubmitCallback(data) {
		handleSubmitCb(data);
	}

	return (
		<div className={styles.continuation_wrapper} data-test={`continuation-form-wrapper`}>
			<EditContinuationActions actions={values.continuationActions} handleSubmitActions={handleSubmitNewContinuationActions} color={color} />
			<div data-test="field-prop-list-item">
				<label style={{ color: color.text.secondary }} className={styles.header} htmlFor="edit_fieldTemplateId">
					Target Field Template Id:
				</label>
				<TextFieldWrapper
					onChange={handleChange}
					value={values.fieldTemplateId}
					name="fieldTemplateId"
					id="edit_fieldTemplateId"
					type="text"
					placeholder="target field template id"
					colorPalette={color}
				/>
			</div>
			<div data-test="field-prop-list-item">
				<label style={{ color: color.text.secondary }} className={styles.header} htmlFor="edit_formTemplateId">
					Target Form Template Id:
				</label>
				<TextFieldWrapper
					onChange={handleChange}
					value={values.formTemplateId}
					name="formTemplateId"
					id="edit_formTemplateId"
					type="text"
					placeholder="target form template id"
					colorPalette={color}
				/>
			</div>
			<div data-test="field-prop-list-item">
				text for instanceToContinueOn: String
				<label style={{ color: color.text.secondary }} className={styles.header} htmlFor="edit_instanceToContinueOn">
					Target Instance to continue on:
				</label>
				<TextFieldWrapper
					onChange={handleChange}
					value={values.instanceToContinueOn}
					name="instanceToContinueOn"
					id="edit_instanceToContinueOn"
					className={styles.text_input}
					type="text"
					placeholder="target instance to continue on"
					colorPalette={color}
				/>
			</div>
			<div data-test="field-prop-list-item" isfancy={"true"} name="parentFormTemplateId">
				ParentFormTemplateId String
				<label style={{ color: color.text.secondary }} className={styles.header}>
					Parent Form Template Id:
				</label>
				<div data-test="parentFormTemplateId-value">{values.parentFormTemplateId}</div>
			</div>

			<button data-test="submit-continuation-data-btn" onClick={handleSubmit}>
				Submit Continuation Data
			</button>
		</div>
	);
}

export default ContinuationDataForm;
